module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/group-382321bdfcddb743b94e8606f11f743c.png";